import React from 'react';
import { Avantaje } from '../../components';
import './whatConta.css';

const WhatConta = () => {
    return (
        <div className='iconta__whatConta section_margin' id='avantaje'>
            <div className='iconta__whatConta-avantaje'>
                <Avantaje title="What is GPT-3" text="We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by."/>
            </div>
            <div className='iconta__whatConta-heading'>
                <h1 className='gradient__text'>The possibilities are beyond your imagination</h1>
            </div>
            <div className='iconta__whatConta-container'>
                <Avantaje title="Chatbots" text="We so opinion friends me message as delight. Whole front do of plate heard oh ought."/>
                <Avantaje title="Knowledgebase" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b"/>
                <Avantaje title="Education" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b"/>
            </div>
        </div>
    )
}

export default WhatConta
